"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AnchorTagModule = _interopRequireDefault(require("./../../scss/utils/AnchorTag.module.scss"));
function AnchorTag({
  href = '',
  classname = '',
  label = '',
  type = 'internal-link',
  image = null
}) {
  if (image !== null) {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      className: [classname, _AnchorTagModule.default['anchor-tag--image'], 'anchor-tag--image'].join(' '),
      rel: type === 'external-link' ? 'noreferrer' : null,
      target: type === 'internal-link' ? '_self' : `_blank`,
      style: {
        '--anchor-tag-image-ratio': image.width / image.height
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: image.url,
      alt: label
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: `sr-only`
    }, label));
  } else {
    return /*#__PURE__*/_react.default.createElement("a", {
      href: href,
      className: classname,
      rel: type === 'external-link' ? 'noreferrer' : null,
      target: type === 'internal-link' ? '_self' : `_blank`
    }, label);
  }
}
var _default = exports.default = AnchorTag;